import React, { useCallback, useState } from "react";
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  FormLabel,
  Grid,
  TextField,
} from "@material-ui/core";
import { getJsonFromString } from "../../../helper";

export default function CustomCommand(props) {
  const { key, isLoading = false, handleSubmitModalCommand = () => { }, commandDetails = {}, } = props?.globalModal.data || {};

  const [details, setDetails] = useState({
    ...commandDetails,
    packet: JSON.stringify(commandDetails?.packet, null, 2),
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDetails((prev) => ({ ...prev, [name]: value }));
  };

  const isValidJsonCommand = useCallback(() => {
    const json = getJsonFromString(details.packet);
    if (!json) return false;
    return Object.values(json).length > 0;
  }, [details.packet]);

  const handleSubmit = () => {
    const request = { ...details };
    // const packet = JSON.parse(details.packet);
    const packet = getJsonFromString(details.packet);
    if (!Array.isArray(packet)) {
      request.packet = [packet, {}];
    }
    handleSubmitModalCommand(key, { ...request, packet });
    props.closeModal();
  };

  return (
    <>
      <DialogTitle className="heat_pump_modal_title">
        <Grid item md={12} className="d-flex">
          <h6>Custom Command</h6>
        </Grid>
      </DialogTitle>
      <DialogContent
        dividers
        className="heat_pump_dialog_content heat-modal-content"
      >
        <FormControl variant="outlined" fullWidth>
          <FormLabel>Topic</FormLabel>
          <TextField
            placeholder="Enter topic"
            name="topic"
            type="text"
            variant="outlined"
            readonly
            disabled
            value={details?.topic || ""}
          />
        </FormControl>
        <FormControl variant="outlined" fullWidth>
          <FormLabel>Command</FormLabel>
          <TextField
            placeholder="Enter command"
            name="packet"
            type="text"
            multiline
            rows={10}
            variant="outlined"
            InputProps={{ className: "p-0" }}
            value={details?.packet || ""}
            onChange={handleChange}
          />
          {details?.packet && !isValidJsonCommand() ? (
            <FormHelperText
              style={{
                color: "red",
                textAlign: "left",
                padding: "0px",
                margin: "0px",
              }}
            >
              Invalid command
            </FormHelperText>
          ) : null}
        </FormControl>
      </DialogContent>
      <Grid>
        <DialogActions className="heat_pump_dialog_action">
          <Button
            className={`cus-btn-modal-submit ${isLoading[key] || !details.topic || !isValidJsonCommand() ? "disabled" : ""}`}
            onClick={isLoading[key] || !details.topic || !isValidJsonCommand() ? null : handleSubmit}
          >
            {isLoading[key] ? <CircularProgress size={18} color="white" /> : "Submit"}
          </Button>
        </DialogActions>
      </Grid>
    </>
  );
}
